<template>
  <div class="featured-products" v-if='show'>
    <div v-if='loading'>
      <img src='https://assets.stihldealer.net/common/spinner.svg' width='20'>
    </div>
    <div v-if="!loading">
      <swiper ref='swiper' class="swiper" :options="swiperOption"
       @click-slide="trackSlideClick"
       @slide-change="trackSlideChange"
       @resize='onResize'>
        <swiper-slide v-for='product in products' :key='product.id'>
          <a :href='product.productLink'>
            <div class='incentive-banner'>
              <div class='incentive-label' v-if='product.hasIncentive'>
                SPECIAL OFFER
              </div>
            </div>
            <div>
              <img :src='product.imageUrl + imagePreset'>
            </div>
            <div class='info'>
              <h3>
                {{ product.name }}
              </h3>
              <div class='stars'>
                <StarRating 
                  :reviewRating="product.reviewStarRating" 
                  :reviewCount="product.reviewCount"
                  :starStyle="{starHeight: 16, starWidth: 16}"/>
              </div>
              <div class='price'>
                {{ getPriceString(product.minPrice, product.maxPrice, product.showPrice) }}
                <span class='dsrp' v-if='product.showPrice'>
                  †DSRP
                </span>
              </div>
            </div>
          </a>
        </swiper-slide>      
      </swiper>
      <div class='nav-wrapper'>
        <div class='swiper-pagination' slot='pagination'></div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import {Swiper, SwiperSlide} from 'vue-awesome-swiper'

import StarRating from '@/components/StarRating.vue'

import 'swiper/css/swiper.css'

const contactForPrice = 'Contact Us For Price'

export default {
  name: 'FeaturedProducts',
  props: {
    max: Number
  },
  data() {
    return {
      loading: false,
      show: true,
      windowWidth: window.innerWidth,
      swiperOption: {
        loop: true,
        slidesPerView: 1.4,
        spaceBetween: 17,
        centeredSlides: true,
        pagination: {
          el: '.swiper-pagination',
          type: 'bullets',
          clickable: 'true',
        },
        breakpoints: {
          768: {
            spaceBetween: 17,
            slidesPerView: 5,
            centeredSlides: false,
          }
        }
      }
    }
  },
  computed: {
    swiper() {
      return this.$refs.swiper.swiperInstance;
    },
    imagePreset() {
      return this.windowWidth < 768 ? '?w=250&h=169&404=product' : '?w=159&h=169&404=product'
    },
    ...mapGetters('Pricing', ['dealer', 'products', 'count']),
  },
  methods: {
    trackSlideClick() {
      this.$dataLayer.push({ 'event': 'pcefp.slide-clicked' })
    },
    trackSlideChange() {
      this.$dataLayer.push({ 'event': 'pcefp.slide-changed' })
    },
    onResize () {
      this.windowWidth = window.innerWidth
    },
    getPriceString(min, max, display) {
      if (display == false) {
        return contactForPrice
      }
      if (min == max) {
        return `$${min.toFixed(2)}`
      }
      return `$${min.toFixed(2)} - $${max.toFixed(2)}`
    },
    slideClick(index, realIndex) {
      var url = this.products[realIndex].productLink
      if (url != '') {
        window.location.href = url
      }
    },
    ...mapActions('Pricing', ['fetchProducts', 'setSelectedVariant'])
  },
  components: {
    Swiper,
    SwiperSlide,
    StarRating
  },
  async created() {
    if (this.dealer == null || this.dealer.id == null) {
      this.show = false;
      return;
    }
    this.loading = true
    this.fetchProducts(this.max).then(
      () =>{
        this.loading = false
        if (this.count <= 0) {
          console.error('[FeaturedProducts] No featured products returned from API.')
          this.show = false
        }
        //do something else on api load?
      },
      () => {
        this.show = false
      })
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
* {
  box-sizing: border-box;
}
.swiper-navigation {
  cursor: pointer;
}
.swiper-pagination {
  position: relative;
  margin: 0 10px;
  line-height: 12px;
}
.nav-wrapper {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 23px;
  padding-bottom: 23px;
}
::v-deep .swiper-pagination-bullet {
  margin: 0px 3px;
  height: 12px;
  width: 12px;
  border: 1px solid $black;
  opacity: 1;
  background: $white;
}
::v-deep .swiper-pagination-bullet-active {
  background: $black;
}
.swiper {
  height: 310px;
  width: 100%;
}
.swiper .swiper-slide {  
  text-align: center;
  font-weight: bold;
  font-size: 18px;      
  background-color: $white;
  cursor: pointer;
}
.swiper .swiper-slide a {
  text-decoration: none;
}
.swiper .swiper-slide a:visited {
  text-decoration: none;
}
.swiper .swiper-slide .incentive-banner {
  height: 24px;
  width: 65%;
}
.swiper .swiper-slide .incentive-banner .incentive-label {
  width: 100%;
  height: 100%;
  color: $white;
  background-color: $primary;
  font-family: $font-title;
  letter-spacing: -0.36px;
  text-shadow: none;
  text-align: center;
  font-size: 12px;
  padding-top: 5px;
}
.swiper .swiper-slide .info {
  color: #444444;
  padding-top: 11px;
  padding-left: 10px;
  padding-right: 10px;
  border-bottom: 2px solid $black;
  text-align: left;
}
.swiper .swiper-slide .info .stars {
  margin-top: 3px;
  margin-bottom: 16px;
}
.swiper .swiper-slide .info h3 {
  padding: 0;
  margin: 0;
  font-size: 14px;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.swiper .swiper-slide .info .price {
  font-size: 14px;
  height: 36px;
  color: $black;
}
.swiper .swiper-slide .info .price .dsrp {
  font-size: 10px;
}

@media only screen and (max-width: 768px) {
  .swiper .swiper-slide .info {
    padding-left: 15px;
    padding-right: 15px;
  }
  .swiper .swiper-slide .info h3 {
    font-size: 16px;
  }
  .swiper .swiper-slide .info .price {
    font-size: 16px; 
  }
  .swiper .swiper-slide .info .price .dsrp {
    font-size: 12px;
  }
  .swiper .swiper-slide .incentive-banner {
    width: 45%;
  }
}
</style>

